export default __webpack_public_path__ + "static/media/banner_bg.fb651202.mp4";